<template>
  <v-dialog v-model="control.modalLeave" persistent max-width="50%">
    <v-card>
      <v-card-title class="accent white--text">
        <v-icon color="white">mdi-alert</v-icon> Édition en cours
      </v-card-title>

      <v-card-text class="body-1">
        <p class="pt-4">
          Vous allez quitter la page actuelle et perdre toutes les modifications
          non sauvegardées.
        </p>
        <p>
          Êtes-vous sûr de vouloir continuer ?
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="quitter">
          Oui
        </v-btn>
        <v-btn text @click="annuler">
          Non
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  inject: ['control'],
  methods: {
    quitter() {
      this.control.modalLeave = false;
      this.control.onConfirmLeave();
    },
    annuler() {
      this.control.modalLeave = false;
    },
  },
};
</script>
